module.exports = __webpack_public_path__ + "static/media/karakter-404.b2e9aa8c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/svg/karakter-404.svg
// module id = 758
// module chunks = 0